// extracted by mini-css-extract-plugin
export default {"container":"admin-laboratory_container__f5LwZ","container__tabsBlock":"admin-laboratory_container__tabsBlock__xwRa3","content":"admin-laboratory_content__BigZU"};